import React, { useEffect, useState, Fragment } from 'react';
import { trackFbEvent } from '../utils/fbPixel';
const comparisonRows = [{
  without: '100+ horas/año buscando resúmenes dispersos',
  with: 'Todo organizado por materia en un solo lugar'
}, {
  without: 'Estudiás de cero cada parcial',
  with: '6 tomos con esquemas y resúmenes listos'
}, {
  without: 'Finales que se acumulan sin saber por dónde empezar',
  with: 'Guía de estudio por materia + banco de preguntas'
}, {
  without: 'TPs y trabajos que te llevan horas',
  with: 'Fichas de autoevaluación para adaptar en 20 min'
}, {
  without: 'Psicoanálisis explicado en 5 libros que no coinciden',
  with: 'Toda la teoría organizada en un solo tomo'
}, {
  without: 'Materias recursadas por falta de estructura',
  with: 'Sistema de estudio inverso → aprobás de primera'
}, {
  without: 'Sin saber qué te van a tomar en el final',
  with: 'Banco de preguntas armado con lo que más toman'
}, {
  without: 'Te recibís sin saber cómo arrancar',
  with: 'Máster Psicología listo para el día uno'
}, {
  without: 'Sin identidad profesional ni sistema de cobro',
  with: 'Contrato + reglamento + presencia digital listos'
}];
const TIMER_KEY = 'megapack_psicologia_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-base leading-6" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FEFAF4 30%, #FEFAF4 70%, #FDF4E7 100%)'
  }} data-id="element-119">
      <div className="mx-auto max-w-4xl text-center" data-id="element-120">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-[18px]" style={{
        color: '#C8922A'
      }} data-id="element-121">
          🧠 MEGAPACK PSICOLOGÍA CARRERA RESUELTA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold m-0 mb-3" style={{
        color: '#1E1208'
      }} data-id="element-122">
          El próximo parcial podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black m-0 mb-10" style={{
        color: '#C8922A'
      }} data-id="element-123">
          O podés entrar con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl text-left" style={{
        backgroundColor: 'rgba(255,255,255,0.97)',
        border: '1px solid rgba(200,146,42,0.22)'
      }} data-id="element-124">
          {/* Table Title */}
          <div className="text-center font-bold px-4 py-4" style={{
          backgroundColor: 'rgba(200,146,42,0.07)',
          borderBottom: '1px solid rgba(200,146,42,0.15)',
          color: '#1E1208'
        }} data-id="element-125">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2" style={{
          backgroundColor: 'rgba(200,146,42,0.05)',
          borderBottom: '1px solid rgba(200,146,42,0.15)'
        }} data-id="element-126">
            <div className="text-center font-bold px-4 py-3 text-sm" style={{
            color: '#9A7B5A'
          }} data-id="element-127">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold px-4 py-3 text-sm" style={{
            color: '#C8922A',
            borderLeft: '1px solid rgba(200,146,42,0.15)'
          }} data-id="element-128">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-2" style={{
          borderBottom: i < comparisonRows.length - 1 ? '1px solid rgba(200,146,42,0.08)' : undefined
        }} data-id="element-129">
              <div className="px-4 py-3 text-xs sm:text-sm" style={{
            color: '#9A7B5A'
          }} data-id="element-130">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold" style={{
            color: '#1E1208',
            borderLeft: '1px solid rgba(200,146,42,0.08)',
            backgroundColor: 'rgba(122,158,126,0.06)'
          }} data-id="element-131">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-132">
          <p className="font-bold m-0 mb-4" style={{
          color: '#1E1208'
        }} data-id="element-133">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-134">
            {[{
            value: timeLeft.hours,
            label: 'hs'
          }, {
            value: timeLeft.minutes,
            label: 'min'
          }, {
            value: timeLeft.seconds,
            label: 'seg'
          }].map((item, i) => <Fragment key={item.label} data-id="element-135">
                <div className="flex flex-col items-center" data-id="element-136">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
                color: 'rgb(255,68,68)'
              }} data-id="element-137">
                    {pad(item.value)}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide" style={{
                color: '#9A7B5A'
              }} data-id="element-138">
                    {item.label}
                  </span>
                </div>
                {i < 2 && <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-139">
                    :
                  </span>}
              </Fragment>)}
          </div>
        </div>

        <p className="text-sm m-0 mb-12" style={{
        color: '#6B4C35'
      }} data-id="element-140">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-141">$15.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-142">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgba(255,255,255,0.95)',
          border: '1px solid rgba(200,146,42,0.22)'
        }} data-id="element-143">
            <div className="mb-2 text-2xl" data-id="element-144">🧠</div>
            <h3 className="text-base font-black m-0 mb-1" style={{
            color: '#1E1208'
          }} data-id="element-145">
              MEGAPACK PSICOLOGÍA CARRERA RESUELTA
            </h3>
            <p className="text-xs m-0 mb-4" style={{
            color: '#9A7B5A'
          }} data-id="element-146">
              6 Tomos + 6 Bonos · Toda la carrera organizada
            </p>
            <div className="mt-auto" data-id="element-147">
              <p className="text-sm line-through m-0 mb-1" style={{
              color: '#9A7B5A'
            }} data-id="element-148">
                Antes: $58.990 ARS
              </p>
              <p className="text-2xl font-black m-0 mb-4" style={{
              color: '#C8922A'
            }} data-id="element-149">
                Hoy: $22.990
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48278094446762:1" onClick={() => trackFbEvent('InitiateCheckout', {
              content_name: 'Megapack Psicología Carrera Resuelta',
              content_category: 'Psicología Carrera Resuelta',
              value: 22990,
              currency: 'ARS'
            })} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)'
            }} data-id="element-150">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm" style={{
          backgroundColor: 'rgba(200,146,42,0.06)',
          border: '2px solid #C8922A',
          boxShadow: 'rgba(200,146,42,0.18) 0px 0px 30px 0px'
        }} data-id="element-151">
            <div className="mb-2 text-2xl" data-id="element-152">🏆</div>
            <h3 className="text-base font-black m-0 mb-1" style={{
            color: '#C8922A'
          }} data-id="element-153">
              MEGAPACK + MÁSTER PSICOLOGÍA ⭐
            </h3>
            <p className="text-xs m-0 mb-1" style={{
            color: '#9A7B5A'
          }} data-id="element-154">
              La más elegida
            </p>
            <p className="text-xs m-0 mb-4" style={{
            color: '#9A7B5A'
          }} data-id="element-155">
              6 Tomos + 6 Bonos + Máster Psicología™
              <br data-id="element-156" />
              (consultorio, cobro, gestión y presencia digital)
            </p>
            <div className="mt-auto" data-id="element-157">
              <p className="text-sm line-through m-0 mb-1" style={{
              color: '#9A7B5A'
            }} data-id="element-158">
                Antes: $102.990 ARS
              </p>
              <p className="text-3xl font-black m-0 mb-4" style={{
              color: '#C8922A'
            }} data-id="element-159">
                Hoy: $29.990
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48278094839978:1" onClick={() => trackFbEvent('InitiateCheckout', {
              content_name: 'Megapack + Máster Psicología',
              content_category: 'Psicología Carrera Resuelta',
              value: 29990,
              currency: 'ARS'
            })} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
            }} data-id="element-160">
                → QUIERO EL MEGAPACK + MÁSTER PSICOLOGÍA
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm" style={{
        color: '#6B4C35'
      }} data-id="element-161">
          <span data-id="element-162">🔒 Pago 100% seguro</span>
          <span data-id="element-163">⚡ Acceso en 5 minutos</span>
          <span data-id="element-164">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-165">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}